// extracted by mini-css-extract-plugin
export default {"main":"MiscDeductionType_main__m6g-P","leaveheading":"MiscDeductionType_leaveheading__UP+a7","div1":"MiscDeductionType_div1__Kvi2q"};